import { Gender, Pupil, Elo } from '@lyceo/homi/pupils/util-models';
import { PersonProfileDto } from './pupil.dto';

export function mapPupil(personProfileDto: PersonProfileDto): Pupil {
  return {
    id: personProfileDto.id,
    firstName: personProfileDto.firstName,
    lastName: personProfileDto.lastName,
    emailAddress: personProfileDto.emailAddress,
    gender: personProfileDto.gender as Gender,
    phoneNumber: personProfileDto.phoneNumber,
    birthDate: personProfileDto.birthDate,
    elo: personProfileDto.pupil?.elo as Elo,
    level: personProfileDto.pupil?.level,
    year: personProfileDto.pupil?.year,
    schoolName: personProfileDto.pupil?.schoolName,
    pupilClass: personProfileDto.pupil?.pupilClass,
    importantPersonIds: personProfileDto.pupil?.importantPersons
      ? personProfileDto.pupil.importantPersons.map(
          (importantPerson) => importantPerson.id,
        )
      : [],
    courseIds: personProfileDto.pupil?.courses
      ? personProfileDto.pupil.courses.map((course) => course.id)
      : [],
  };
}
